//
// Main navigation and mobile show hide JavaScript functions
//
window.addEventListener('DOMContentLoaded', () => {

    const html = document.documentElement;
    const body = document.body;
    const mobileShowNav = document.querySelector('#nav-mobile-toggle');
    const mainNavigation = document.querySelector('#main-navigation');
    const mobileBacklink = document.querySelector('#mobile-backlink');
    const mobileDivider = document.querySelector('.header__mobile__controls__divider');
    const subMenuZero =
        document.querySelectorAll('.sub-menu-wrapper');
    
    // Store reference to current active back link
    let currentBackLink = null;
    
    // Function to show/hide mobile backlink button
    function updateMobileBacklink(backLink) {
        if (backLink) {
            currentBackLink = backLink;
            mobileBacklink.classList.add('active');
            if (mobileDivider) mobileDivider.classList.add('active');
        } else {
            currentBackLink = null;
            mobileBacklink.classList.remove('active');
            if (mobileDivider) mobileDivider.classList.remove('active');
        }
    }
    
    // Click handler for mobile backlink button
    if (mobileBacklink) {
        mobileBacklink.addEventListener('click', function(e) {
            e.preventDefault();
            if (currentBackLink) {
                currentBackLink.click();
            }
        });
    }

    // Open submenu panels up to the level of the current page so siblings are reachable
    function openActiveMenuPath() {
        const currentItem = mainNavigation.querySelector('.current-menu-item');
        if (!currentItem) return;

        // Open level-1 panel first (deepest) if current item lives inside one
        const level1Wrapper = currentItem.closest('.sub-menu-wrapper.level-1');
        if (level1Wrapper) {
            const level1SubMenu = level1Wrapper.querySelector('.sub-menu');
            const level1Parent = level1Wrapper.closest('.menu-item-has-children');
            if (level1SubMenu && level1Parent) {
                const anchor1 = Array.from(level1Parent.children).find(el => el.tagName === 'A');
                const link1 = document.createElement('a');
                link1.href = 'javascript:';
                link1.textContent = anchor1 ? anchor1.textContent.trim() : '';
                const li1 = document.createElement('li');
                li1.classList.add('back');
                li1.appendChild(link1);
                link1.addEventListener('click', function (e) {
                    e.preventDefault();
                    level1SubMenu.classList.remove('open');
                    level1Wrapper.classList.remove('open');
                    level1Parent.classList.remove('open');
                    if (level1SubMenu.contains(li1)) level1SubMenu.removeChild(li1);
                    level1SubMenu.style.setProperty('--submenu-height', '0px');
                    // Update mobile backlink to level-0 back link if it exists
                    const level0Back = mainNavigation.querySelector('.sub-menu-wrapper.level-0.open .sub-menu > .back a');
                    updateMobileBacklink(level0Back);
                });
                level1SubMenu.prepend(li1);
                level1Parent.classList.add('open');
                level1SubMenu.classList.add('open');
                level1Wrapper.classList.add('open');
                setTimeout(function () {
                    level1SubMenu.style.setProperty('--submenu-height', level1SubMenu.scrollHeight + 'px');
                }, 0);
                // Show mobile backlink for level-1
                updateMobileBacklink(link1);
            }
        }

        // Open level-0 panel if current item lives inside one
        const level0Wrapper = currentItem.closest('.sub-menu-wrapper.level-0');
        if (level0Wrapper) {
            const level0SubMenu = level0Wrapper.querySelector('.sub-menu');
            const level0Parent = level0Wrapper.closest('.menu-item-has-children');
            if (level0SubMenu && level0Parent) {
                const anchor0 = Array.from(level0Parent.children).find(el => el.tagName === 'A');
                const link0 = document.createElement('a');
                link0.href = 'javascript:';
                link0.textContent = anchor0 ? anchor0.textContent.trim() : '';
                const li0 = document.createElement('li');
                li0.classList.add('back');
                li0.appendChild(link0);
                link0.addEventListener('click', function () {
                    level0SubMenu.classList.remove('open');
                    level0Wrapper.classList.remove('open');
                    if (level0SubMenu.contains(li0)) level0SubMenu.removeChild(li0);
                    level0SubMenu.style.setProperty('--submenu-height', '0px');
                    // Hide mobile backlink when closing level-0
                    updateMobileBacklink(null);
                });
                level0SubMenu.prepend(li0);
                level0SubMenu.classList.add('open');
                level0Wrapper.classList.add('open');
                setTimeout(function () {
                    level0SubMenu.style.setProperty('--submenu-height', level0SubMenu.scrollHeight + 'px');
                }, 0);
                // Show mobile backlink for level-0 (only if no level-1 is open)
                if (!level1Wrapper) {
                    updateMobileBacklink(link0);
                }
            }
        }
    }

    // Mobile icon on click
    mobileShowNav.addEventListener('click', function () {
        // Toggle the needed classes.
        html.classList.toggle('nav-open');
        body.classList.toggle('nav-open');
        mobileShowNav.classList.toggle('nav-open');
        mainNavigation.classList.toggle('nav-open');
        // Keep the toggle's aria-expanded in sync with the panel it controls
        mobileShowNav.setAttribute(
            'aria-expanded',
            mainNavigation.classList.contains('nav-open') ? 'true' : 'false'
        );
        // Reset all submenu open state (wrappers, sub-menus, parent items)
        mainNavigation.querySelectorAll('.sub-menu-wrapper, .sub-menu, .menu-item-has-children').forEach(el => {
            el.classList.remove('open');
        });
        // Remove all back buttons
        mainNavigation.querySelectorAll('.back').forEach(e => e.remove());
        // Hide mobile backlink when closing nav
        if (!mainNavigation.classList.contains('nav-open')) {
            updateMobileBacklink(null);
        }
        // If menu is now open, expand panels to the current page's level
        if (mainNavigation.classList.contains('nav-open')) {
            openActiveMenuPath();
        }
    });

    if (mainNavigation) {
        const itemHasChildren = document.querySelectorAll(
            '.menu-item-has-children'
        );

        itemHasChildren.forEach((menuItem) => {
            const arrowRight =
                document.createElement('span');
            arrowRight.innerHTML +=
                '<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M4.175 5.575L0.275 1.675C0.0916667 1.49167 0 1.25833 0 0.975C0 0.691667 0.0916667 0.458333 0.275 0.275C0.458333 0.0916667 0.691667 0 0.975 0C1.25833 0 1.49167 0.0916667 1.675 0.275L6.275 4.875C6.375 4.975 6.44583 5.08333 6.4875 5.2C6.52917 5.31667 6.55 5.44167 6.55 5.575C6.55 5.70833 6.52917 5.83333 6.4875 5.95C6.44583 6.06667 6.375 6.175 6.275 6.275L1.675 10.875C1.49167 11.0583 1.25833 11.15 0.975 11.15C0.691667 11.15 0.458333 11.0583 0.275 10.875C0.0916667 10.6917 0 10.4583 0 10.175C0 9.89167 0.0916667 9.65833 0.275 9.475L4.175 5.575Z" fill="white"/>\n' +
                '</svg>';
            arrowRight.classList.add('arrow');
            menuItem.prepend(arrowRight);

            arrowRight.addEventListener(
                'click',
                function () {
                    const parentLink = this;
                    const parent = this.closest(
                        '.menu-item-has-children'
                    );
                    const subMenuWrapper =
                        parent.querySelector(
                            '.sub-menu-wrapper.level-0'
                        );
                    if (!subMenuWrapper) return;
                    const subMenuZero = subMenuWrapper.querySelector('.sub-menu');

                    if (subMenuZero) {
                        // Add title above sub items.
                        let link =
                            document.createElement('a');
                        link.href = 'javascript:';
                        link.innerHTML =
                            parentLink.nextSibling.text;

                        let liElement =
                            document.createElement('li');
                        liElement.classList.add('back');
                        liElement.appendChild(link);

                        link.addEventListener(
                            'click',
                            function () {
                                subMenuZero.classList.remove(
                                    'open'
                                );
                                subMenuWrapper.classList.remove('open');

                                subMenuZero.removeChild(
                                    liElement
                                );
                                // Clear the CSS variable
                                subMenuZero.style.setProperty('--submenu-height', '0px');
                                // Hide mobile backlink when closing level-0
                                updateMobileBacklink(null);
                            }
                        );

                        subMenuZero.prepend(liElement);

                        // Set CSS variable with the submenu height
                        setTimeout(() => {
                            const height = subMenuZero.scrollHeight;
                            subMenuZero.style.setProperty('--submenu-height', height + 'px');
                        }, 0);

                        // Show submenu
                        subMenuZero.classList.add('open');
                        subMenuWrapper.classList.add('open');

                        // Show mobile backlink for level-0
                        updateMobileBacklink(link);
                    }
                }
            );
        });

        const subItemHasChildren =
            document.querySelectorAll(
                '.sub-menu-wrapper.level-0 .menu-item-has-children'
            );
        subItemHasChildren.forEach((subMenuItem) => {
            const arrow =
                subMenuItem.querySelector('.arrow');

            if (arrow) {
                arrow.classList.add('down');
            }

            arrow.addEventListener('click', function () {
                const parent = this.closest(
                    '.menu-item-has-children'
                );

                parent.classList.toggle('open');
                const subMenuWrapper = parent.querySelector(
                    '.sub-menu-wrapper.level-1'
                );
                if (!subMenuWrapper) return;
                const subMenuOne = subMenuWrapper.querySelector('.sub-menu');

                if (subMenuOne) {
                    const isOpening = !subMenuOne.classList.contains('open');
                    subMenuOne.classList.toggle('open');

                    if (isOpening) {
                        // Add back item to level-1 submenu
                        let link = document.createElement('a');
                        link.href = 'javascript:';
                        link.innerHTML = this.nextSibling.text;

                        let liElement = document.createElement('li');
                        liElement.classList.add('back');
                        liElement.appendChild(link);

                        link.addEventListener('click', function (e) {
                            e.preventDefault();
                            subMenuOne.classList.remove('open');
                            subMenuWrapper.classList.remove('open');
                            parent.classList.remove('open');
                            subMenuOne.removeChild(liElement);
                            // Clear the CSS variable
                            subMenuOne.style.setProperty('--submenu-height', '0px');
                            // Update mobile backlink to level-0 back link
                            const level0Back = mainNavigation.querySelector('.sub-menu-wrapper.level-0.open .sub-menu > .back a');
                            updateMobileBacklink(level0Back);
                        });

                        subMenuOne.prepend(liElement);

                        // Set CSS variable with the submenu height
                        setTimeout(() => {
                            const height = subMenuOne.scrollHeight;
                            subMenuOne.style.setProperty('--submenu-height', height + 'px');
                        }, 0);

                        // Show mobile backlink for level-1
                        updateMobileBacklink(link);
                    } else {
                        // Remove back item when closing
                        const backItem = subMenuOne.querySelector('li.back');
                        if (backItem) {
                            subMenuOne.removeChild(backItem);
                        }
                        // Clear the CSS variable
                        subMenuOne.style.setProperty('--submenu-height', '0px');
                        // Update mobile backlink to level-0 back link
                        const level0Back = mainNavigation.querySelector('.sub-menu-wrapper.level-0.open .sub-menu > .back a');
                        updateMobileBacklink(level0Back);
                    }
                }
                subMenuWrapper.classList.toggle('open');
            });
        });
    }
});

